export const checklistSubSectionNavMixin = {
  computed: {
    subSectionNav() {
      if(!this.$route.params.id) return null;
      return [
        { to: { name: 'admin_checklist_templates_edit', params: { id: this.$route.params.id } }, label: 'Edit' },
        { to: { name: 'admin_checklist_templates_edit_item', params: { id: this.$route.params.id } }, label: 'Manage Checklist Items' },
      ]
    }
  }
}
